import React from "react";
import { Link } from "react-router-dom";
import {
  FiBriefcase,
  FiCalendar,
  FiCheckCircle,
  FiMail,
  FiMapPin,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import { isCreativeUserRecord } from "../utils/buttonVisibility";

const Profile = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const isCreative = isCreativeUserRecord(user);
  const displayName = [user?.firstName, user?.lastName]
    .filter(Boolean)
    .join(" ");
  const initials =
    [user?.firstName, user?.lastName]
      .filter(Boolean)
      .map((value) => value.charAt(0))
      .join("")
      .toUpperCase() || "U";
  const roleLabel = [user?.position, user?.department || user?.team]
    .filter(Boolean)
    .join(" • ");

  const profileFields = [
    { label: "Username", value: user?.username, icon: <FiMail /> },
    { label: "Department", value: user?.department, icon: <FiBriefcase /> },
    { label: "Team", value: user?.team, icon: <FiUsers /> },
    { label: "Team Group", value: user?.teamGroup, icon: <FiMapPin /> },
    { label: "Position", value: user?.position, icon: <FiUser /> },
    { label: "Company", value: user?.company, icon: <FiBriefcase /> },
  ];

  if (!isCreative) {
    profileFields.splice(1, 0, {
      label: "Level",
      value: user?.level,
      icon: <FiCheckCircle />,
    });
  }

  const quickLinks = [
    {
      title: "Meeting Room Booking",
      description: "จองห้องประชุมและดูตารางใช้งาน",
      to: "/meeting-rooms",
      icon: <FiCalendar />,
    },
    {
      title: "Travel Expense",
      description: "ดูและจัดการคำขอเดินทางของคุณ",
      to: "/travel-expense",
      icon: <FiMapPin />,
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-900 transition-colors duration-300 px-4 py-6 md:px-8">
      <div className="mx-auto max-w-6xl space-y-6">
        {user ? (
          <>
            <section className="overflow-hidden rounded-xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
              <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-cyan-800 px-6 py-7 text-white">
                <div className="flex flex-col gap-5 md:flex-row md:items-center">
                  <div className="flex items-center gap-4">
                    <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-white/15 text-xl font-semibold ring-1 ring-white/30">
                      {initials}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-cyan-100">
                        {isCreative ? "Profile Workspace" : "User Profile"}
                      </p>
                      <h1 className="mt-1 text-2xl font-semibold">
                        {displayName || user.username || "User"}
                      </h1>
                      <p className="mt-1 text-sm text-slate-200">
                        {roleLabel || "OPTX Team Member"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              {profileFields.map((field) => (
                <div
                  key={field.label}
                  className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm dark:border-gray-700 dark:bg-gray-800"
                >
                  <div className="flex items-start gap-3">
                    <span className="mt-0.5 rounded-lg bg-slate-100 p-2 text-slate-700 dark:bg-gray-700 dark:text-gray-200">
                      {field.icon}
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-500 dark:text-gray-400">
                        {field.label}
                      </p>
                      <p className="mt-1 break-words text-base font-semibold text-slate-900 dark:text-gray-100">
                        {field.value || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </section>

            <section>
              <div className="mb-3 flex items-center justify-between">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-gray-100">
                  Quick Actions
                </h2>
              </div>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {quickLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="group rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-cyan-300 hover:shadow-md dark:border-gray-700 dark:bg-gray-800 dark:hover:border-cyan-700"
                  >
                    <div className="flex items-center gap-3">
                      <span className="rounded-lg bg-cyan-50 p-3 text-cyan-700 transition group-hover:bg-cyan-100 dark:bg-cyan-950/50 dark:text-cyan-200">
                        {item.icon}
                      </span>
                      <div>
                        <h3 className="font-semibold text-slate-900 dark:text-gray-100">
                          {item.title}
                        </h3>
                        <p className="mt-1 text-sm text-slate-500 dark:text-gray-400">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          </>
        ) : (
          <div className="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-600 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400">
            ไม่พบข้อมูลผู้ใช้งานในระบบ
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
